import React, { useState,useContext } from 'react';
import { useApiFetch } from '../../utils/useApiFetch';
import { TokenContext } from '../../Context/TokenContext';
import { getApiBaseUrl } from '../../utils/Config';
import { AlertContext } from '../../Context/AlertContext';
import { useIsAuthenticated } from "../../utils/msalCompat";
import { CandidateContext } from '../../Context/CandidateContext';
import skillsList from '../../utils/skills.json';

function SkillsAddForm({ updateSkillItems, candidateID, displayResponseMessage, onCancel }) {
    const isAuthenticated = useIsAuthenticated();
    const apiFetch = useApiFetch();
    const { refetchCandidateDetails } = useContext(CandidateContext)
    const { idTokenClaims } = useContext(TokenContext);
    const [saving, setSaving] = useState(false);
    const baseUrl = getApiBaseUrl();
    const { showAlert } = useContext(AlertContext);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

   
    const [formData, setFormData] = useState({
        Name: '',
        YearsExperience: '',
    });
    const [errors, setErrors] = useState({
        Name: '',
        YearsExperience: '',
    });
    const handleInputChange = (event) => {
        const { name, type, value, checked } = event.target;
        const val = type === "checkbox" ? checked : value;

        setFormData(prevData => ({
            ...prevData,
            [name]: val
        }));

        if (name === 'Name') {
            const input = val.trim();

            if (input.length >= 2) {
                const filtered = skillsList.filter(skill =>
                    skill.toLowerCase().includes(input.toLowerCase())
                );
                setFilteredSuggestions(filtered);
                setShowSuggestions(true);
            } else {
                // If too short or cleared, hide the suggestions
                setFilteredSuggestions([]);
                setShowSuggestions(false);
            }
        }


    };


    //Validation
    const validate = () => {
        const newErrors = {};

        // Allow letters, numbers, spaces, dashes, plus, hash, periods, pipes, and commas
        const allowedRegex = /^[a-zA-Z0-9\s#.+-,|()]+$/;

        if (!formData.Name) {
            newErrors.Name = 'Skill is required.';
        } else if (!allowedRegex.test(formData.Name)) {
            newErrors.Name = 'Skill name contains invalid characters.';
        } else if (formData.Name.length > 100) {
            newErrors.Name = 'Skill name should not exceed 100 characters.';
        }

        if (!formData.YearsExperience) {
            newErrors.YearsExperience = 'Years of Experience is required.';
        }

        setErrors(newErrors);
        return Object.values(newErrors).every(error => !error);
    };


    //Submit to API
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            if (saving) {
                return;
            }
            setSaving(true);

            const dataToPost = {
                ...formData,
                Description: 'None',
                SkillLevelTypeID: 1,
                CandidateID: candidateID,
                DateTimeCreated: new Date().toISOString(),
                DateTimeModified: new Date().toISOString(),
                CreatedBy: 'Admin',
                ModifiedBy: 'User',
                IsDeleted: false,
                AuthUserID: idTokenClaims.oid,
            };

            try {
                const response = await apiFetch(
                    `${baseUrl}/api/Skill/Upsert`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(dataToPost),
                    }
                );
                const responseData = await response.json();

                if (responseData.success) {
                    showAlert('Saved successfully.', true);
                    refetchCandidateDetails();
                } else {
                    showAlert(responseData.message || 'Something went wrong. Please try again.', false);
                }
            }
            catch (error) {
                showAlert('Something went wrong. Please try again.', false);
            }
            finally {
                setSaving(false);
            }

        }
    };
    if (!isAuthenticated) {
        return <div>Please log in to access the dashboard.</div>;
    }
    return (
        <div className="skill-create-form stealth-inn">
            <form onSubmit={handleSubmit}>
                <div className="skill-item-edit">
                    <div className="skill-edit card-body-iajj">
                        <input type="hidden" className="form-control" value={candidateID} name="candidateID" readOnly />

                        <div className="row g-5">
                            <div className="col-md-6">

                                <div className="position-relative">
                                    <label className="form-label">Top Skills</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Name"
                                        placeholder="Search for a skill"
                                        value={formData.Name}
                                        onChange={handleInputChange}
                                        autoComplete="off"
                                        onBlur={() => setTimeout(() => setShowSuggestions(false), 100)}
                                        onFocus={() => {
                                            if (formData.Name.length >= 2 && filteredSuggestions.length > 0) {
                                                setShowSuggestions(true);
                                            }
                                        }}
                                    />


                                    {errors.Name && <small className="text-danger">{errors.Name}</small>}
                                    {showSuggestions && filteredSuggestions.length > 0 && (
                                        <ul className="dropdown-menu show position-absolute w-100">
                                            {filteredSuggestions.map((suggestion, index) => (
                                                <li
                                                    key={index}
                                                    className="dropdown-item"
                                                    onMouseDown={() => {
                                                        setFormData({ ...formData, Name: suggestion });
                                                        setFilteredSuggestions([]);
                                                        setShowSuggestions(false);
                                                    }}
                                                >
                                                    {suggestion}
                                                </li>
                                            ))}
                                        </ul>
                                    )}


                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Years Experience</label>
                                <select className="form-select" value={formData.YearsExperience} name="YearsExperience" id="YearsExperienceSelect" onChange={handleInputChange}>
                                    <option value="">--Select--</option>
                                    <option value="0 - 1">0 to 1 Years</option>
                                    <option value="1 - 3">1 to 3 Years</option>
                                    <option value="3 - 5">3 to 4 Years</option>
                                    <option value="5 - 7">5 to 7 Years</option>
                                    <option value="7+">7+ Years</option>
                                </select>
                                {errors.YearsExperience && <small className="text-danger">{errors.YearsExperience}</small>}

                            </div>
                            <div className="col-12 text-end">
                                <button type="submit" className="btn btn-sm me-2 btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                                <button type="button" className="btn btn-sm btn-neutral me-2" onClick={onCancel}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default SkillsAddForm;
